import { render, staticRenderFns } from "./MppDictCategory.vue?vue&type=template&id=564eff9b&scoped=true&"
import script from "./MppDictCategory.vue?vue&type=script&lang=js&"
export * from "./MppDictCategory.vue?vue&type=script&lang=js&"
import style0 from "./MppDictCategory.vue?vue&type=style&index=0&id=564eff9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564eff9b",
  null
  
)

export default component.exports